import m from 'mithril'
import { createPopper } from '@popperjs/core'



const Tooltip = {}

Tooltip.oncreate = vnode => {
	vnode.state.tooltip = createPopper(vnode.dom.parentElement, vnode.dom, vnode.attrs)
}

Tooltip.onremove = vnode => {
	vnode.state.tooltip.destroy()
}

Tooltip.view = vnode => {
	return vnode.children
}



export default Tooltip
